@import '~style-sheet-helpers/core.less';

.shipment-status-icon-tooltip-message {
  font-size: 12px;
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }

  > span {
    margin-right: 5px;
  }
}
